export default {
    title: {
        new: "添加新地址",
        complete: "完整地址",
        edit: "编辑地址"
    },
    incomplete: "请填写必填地址字段",
    info: {
        "CHN": "Please enter your address in Chinese. </br>请用中文输入你的地址.",
        "BGR": "用英文输入您的<b>家庭住址</b>以接收您的物品。",
        "PRI": "请输入您的家庭住址（而不是邮政信箱）来接收包裹。",
        "SGP": "请在您的地址中注明您的单位号码。",
        "SVK": "请用<b>英文</b>输入您的地址",
        "POL": "请用<b>英文</b>输入您的地址"
    },
    model: {
        country: {
            label: "国家"
        }
    },
    field: {
        default: {
            "name": {
                "label": {
                    "Name": "姓名"
                },
                "placeholder": {
                    "Name": "姓名",
                    "Name in English": "英文名"
                }
            },
            personalEmail: {
                label: {
                    "Personal Email": "个人邮箱"
                },
                placeholder: {
                    "Personal Email": "个人邮箱"
                }
            },
            managerEmail: {
                label: {
                    "Manager Email": "经理邮箱"
                },
                placeholder: {
                    "Manager Email": "经理邮箱"
                }
            },
            managerName: {
                label: {"Manager Name": "经理姓名"},
                placeholder: {"Manager Name": "经理姓名"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "邮政编码",
                    "Post Code": "邮政编码",
                    "Postal Code": "邮政编码",
                    "CPA": "注册会计师"
                },
                "placeholder": {
                    "Zipcode": "邮政编码",
                    "Post Code": "邮政编码",
                    "Postal Code": "邮政编码",
                    "CPA": "注册会计师"
                }
            },
            "province": {
                "label": {
                    "Province": "省",
                    "Prefecture": "州",
                    "Province/Region": "省/地区",
                    "Province Code": "省份代码"
                },
                "placeholder": {
                    "Province": "省",
                    "Prefecture": "州",
                    "Province/Region": "省/地区",
                    "Province Code": "省份代码"
                }
            },
            "phoneNumber": {
                "label": {
                    "Phone Number": "电话号码"
                },
                "placeholder": {
                    "Phone Number": "电话号码"
                }
            },
            "secondaryPhoneNumber": {
                "label": {"Secondary Phone Number": "备用电话号码"},
                "placeholder": {"Secondary Phone Number": "备用电话号码"}
            },
            "firstStreet": {
                "label": {
                    "Street": "街道",
                    "Tax ID": "税号"
                },
                "placeholder": {
                    "Street": "街道",
                    "Street in English": "街道的英文",
                    "Tax ID (RUT)": "税号 (RUT)",
                    "Number/Street/Apartment": "门牌号/街道/公寓"
                }
            },
            "secondStreet": {
                "label": {
                    "District": "区",
                    "Colonia": "科隆",
                    "Canton": "广州",
                    "Street": "街道"
                },
                "placeholder": {
                    "District": "区",
                    "Colonia": "科隆",
                    "Canton": "广州",
                    "Number/Street/Apartment": "门牌号/街道/公寓"
                }
            },
            "city": {
                "label": {
                    "City": "城市",
                    "Town/City/Locality": "城镇/城市/地区",
                    "Town/City": "城镇/城市",
                    "City/Municipality/Locality": "城市/市政/地区",
                    "City/Town/Locality": "城市/城镇/地区",
                    "City/Town": "城市/城镇",
                    "District": "区",
                    "City/Town/Locallity": "城市/城镇/地区",
                    "Town/City/Sub Locality": "城镇/城市/分区"
                },
                "placeholder": {
                    "City": "城市",
                    "Town/City": "城镇/城市",
                    "Town/City/Locality": "城镇/城市/地区",
                    "City/Municipality/Locality": "城市/市政/地区",
                    "City/Town/Locality": "城市/城镇/地区",
                    "City/Town in English": "城市/城镇（英语）",
                    "District": "区",
                    "City/Town/Locallity": "城市/城镇/地区",
                    "Town/City/Sub Locality": "城镇/城市/分区"
                }
            },
            identifier: {
                label: {
                    "identifier": "标识符",
                    "Identifier": "标识符"
                },
                placeholder: {
                    "identifier": "标识符",
                    "Identifier": "标识符"
                }
            },
            "region": {
                "label": {
                    "Region": "地区",
                    "County": "县",
                    "Locality": "局部性"
                },
                "placeholder": {
                    "Region": "地区",
                    "County": "县",
                    "Locality": "局部性"
                }
            },
            "poBox": {
                "label": {
                    "PO BOX": "邮政信箱"
                },
                "placeholder": {
                    "PO BOX": "邮政信箱"
                }
            },
            state: {
                "label": {
                    "State": "状态",
                    "Province/Region": "省/地区",
                    "Province": "省",
                    "Department": "部门",
                    "Municipality/Comuna": "市政当局"
                },
                "placeholder": {
                    "State": "状态",
                    "Province/Region": "省/地区",
                    "Province": "省",
                    "Department": "部门",
                    "Municipality/Comuna": "市政当局"
                },
                options: {
                    "Alabama": "阿拉巴马州",
                    "Alaska": "阿拉斯加州",
                    "Arizona": "亚利桑那",
                    "Arkansas": "阿肯色州",
                    "California": "加利福尼亚州",
                    "Colorado": "科罗拉多州",
                    "Connecticut": "康涅狄格州",
                    "Delaware": "特拉华州",
                    "District Of Columbia": "哥伦比亚特区",
                    "Florida": "佛罗里达",
                    "Georgia": "乔治亚州",
                    "Hawaii": "夏威夷",
                    "Idaho": "爱达荷州",
                    "Illinois": "伊利诺伊州",
                    "Indiana": "印第安纳州",
                    "Iowa": "爱荷华州",
                    "Kansas": "堪萨斯州",
                    "Kentucky": "肯塔基州",
                    "Louisiana": "路易斯安那州",
                    "Maine": "缅因州",
                    "Maryland": "马里兰州",
                    "Massachusetts": "马萨诸塞州",
                    "Michigan": "密歇根州",
                    "Minnesota": "明尼苏达州",
                    "Mississippi": "密西西比州",
                    "Missouri": "密苏里州",
                    "Montana": "蒙大拿",
                    "Nebraska": "内布拉斯加州",
                    "Nevada": "内华达州",
                    "New Hampshire": "新罕布什尔",
                    "New Jersey": "新泽西州",
                    "New Mexico": "新墨西哥州",
                    "New York": "纽约",
                    "North Carolina": "北卡罗来纳州",
                    "North Dakota": "北达科他州",
                    "Ohio": "俄亥俄州",
                    "Oklahoma": "俄克拉荷马州",
                    "Oregon": "俄勒冈州",
                    "Pennsylvania": "宾夕法尼亚州",
                    "Rhode Island": "罗德岛",
                    "South Carolina": "南卡罗来纳州",
                    "South Dakota": "南达科他州",
                    "Tennessee": "田纳西州",
                    "Texas": "德克萨斯州",
                    "Utah": "犹他州",
                    "Vermont": "佛蒙特",
                    "Virginia": "弗吉尼亚州",
                    "Washington": "华盛顿",
                    "West Virginia": "西弗吉尼亚州",
                    "Wisconsin": "威斯康星州",
                    "Wyoming": "怀俄明州"
                }
            },
            "deliveryInstructions": {
                "label": {
                    "Delivery Instructions": "送货说明"
                },
                "placeholder": {
                    "Extra address information, delivery instructions, etc. ": "额外的地址信息、送货说明等。 ",
                    "Extra address information, delivery instructions, etc. in English ": "额外的地址信息、送货说明等（英文） ",
                    "Extra address information, delivery instructions, etc": "额外的地址信息、送货说明等。"
                }
            },
        },
        BRA: {
            name: {
                label: {"Full name": "姓名"},
                placeholder: {"Full name": "姓名"}
            },
            firstStreet: {
                label: {"Address 1": "地址 1"},
                placeholder: {"Address 1": "街道+门牌号/公寓号"}
            },
            secondStreet: {
                label: {
                    "Address 2": "地址 2",
                    "District": "区"
                },
                placeholder: {
                    "Address 2": "街道+门牌号/公寓号",
                    "District": "区"
                }
            },
            city: {
                label: {City: "城市"},
                placeholder: {City: "城市"},
            },
            state: {
                label: {State: "状态"},
                placeholder: {State: "状态"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "邮政编码",
                    "Post Code": "邮政编码",
                    "Postal Code": "邮政编码",
                    "CPA": "注册会计师"
                },
                "placeholder": {
                    "Zipcode": "邮政编码",
                    "Post Code": "邮政编码",
                    "Postal Code": "邮政编码",
                    "CPA": "注册会计师"
                }
            },
            identifier: {
                "label": {
                    "Tax ID": "税号"
                },
                "placeholder": {
                    "Tax ID (CDI, CUIT, CUIL, etc)": "税号（CDI、CUIT、CUIL 等）"
                }
            }
        },
        IND: {
            state: {
                label: {"State/Territory": "州/领地"},
                options: {
                    "Andaman and Nicobar Islands": "安达曼和尼科巴群岛",
                    "Arunachal Pradesh": "阿鲁纳恰尔邦",
                    "Assam": "阿萨姆",
                    "Bihar": "比哈尔邦",
                    "Chandigarh": "昌迪加尔",
                    "Chhattisgarh": "恰蒂斯加尔邦",
                    "Dadra and Nagar Haveli and Daman and Diu": "达德拉和纳加尔哈维利以及达曼和迪乌",
                    "Delhi": "德里",
                    "Goa": "果阿",
                    "Gujarat": "古吉拉特邦",
                    "Haryana": "哈里亚纳邦",
                    "Himachal Pradesh": "喜马偕尔邦",
                    "Jammu and Kashmir": "查谟和克什米尔",
                    "Jharkhand": "贾坎德邦",
                    "Karnataka": "卡纳塔克邦",
                    "Kerala": "喀拉拉邦",
                    "Ladakh":"Ladakh",
                    "Lakshadweep": "拉克沙群岛",
                    "Madhya Pradesh": "中央邦",
                    "Maharashtra": "马哈拉施特拉邦",
                    "Manipur": "曼尼普尔邦",
                    "Meghalaya": "梅加拉亚邦",
                    "Mizoram": "米佐拉姆邦",
                    "Nagaland": "那加兰邦",
                    "Odisha": "奥里萨邦",
                    "Puducherry": "本地治里",
                    "Punjab": "旁遮普",
                    "Rajasthan": "拉贾斯坦邦",
                    "Sikkim": "锡金",
                    "Tamil Nadu": "泰米尔纳德邦",
                    "Telangana":"Telangana",
                    "Tripura": "特里普拉邦",
                    "Uttar Pradesh": "北方邦",
                    "Uttarakhand": "北阿坎德邦",
                    "West Bengal": "西孟加拉邦",
                    "Andhra Pradesh": "安得拉邦"
                }
            }
        }
    },
    errors: {
        required: "{field} 是必需的。",
        mask: "{field} 无效。"
    },
    buttons: {
        submit: {
            text: "节省",
            saving: "保存"
        },
        cancel: {
            text: "取消"
        }
    },
    disclaimer: "添加此地址需要验证邮箱地址。保存地址后，请查看您的邮箱并点击其中的链接。",
    message: {
        added: "地址已添加",
        updated: "地址已更新"
    }
}